const COMMONSEC = {
  top:
    'data:image/png;base64,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',
  bottom:
    'data:image/png;base64,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'
}
var base64encodechars =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
var base64decodechars = new Array(
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  62,
  -1,
  -1,
  -1,
  63,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  -1,
  -1,
  -1,
  -1,
  -1
)
var base64encode = function(str) {
  var out, i, len, c1, c2, c3
  ;(len = str.length), (i = 0), (out = '')
  while (i < len) {
    c1 = str.charCodeAt(i++) & 255
    if (i == len) {
      ;(out += base64encodechars.charAt(c1 >> 2)),
        (out += base64encodechars.charAt((c1 & 3) << 4)),
        (out += '==')
      break
    }
    c2 = str.charCodeAt(i++)
    if (i == len) {
      ;(out += base64encodechars.charAt(c1 >> 2)),
        (out += base64encodechars.charAt(((c1 & 3) << 4) | ((c2 & 240) >> 4))),
        (out += base64encodechars.charAt((c2 & 15) << 2)),
        (out += '=')
      break
    }
    ;(c3 = str.charCodeAt(i++)),
      (out += base64encodechars.charAt(c1 >> 2)),
      (out += base64encodechars.charAt(((c1 & 3) << 4) | ((c2 & 240) >> 4))),
      (out += base64encodechars.charAt(((c2 & 15) << 2) | ((c3 & 192) >> 6))),
      (out += base64encodechars.charAt(c3 & 63))
  }
  return out
}
var base64decode = function(e) {
  var t, n, r, i, s, o, u
  ;(o = e.length), (s = 0), (u = '')
  while (s < o) {
    do t = base64decodechars[e.charCodeAt(s++) & 255]
    while (s < o && t == -1)
    if (t == -1) break
    do n = base64decodechars[e.charCodeAt(s++) & 255]
    while (s < o && n == -1)
    if (n == -1) break
    u += String.fromCharCode((t << 2) | ((n & 48) >> 4))
    do {
      r = e.charCodeAt(s++) & 255
      if (r == 61) return u
      r = base64decodechars[r]
    } while (s < o && r == -1)
    if (r == -1) break
    u += String.fromCharCode(((n & 15) << 4) | ((r & 60) >> 2))
    do {
      i = e.charCodeAt(s++) & 255
      if (i == 61) return u
      i = base64decodechars[i]
    } while (s < o && i == -1)
    if (i == -1) break
    u += String.fromCharCode(((r & 3) << 6) | i)
  }
  return u
}
var utf16to8 = function(e) {
  var t, n, r, i
  ;(t = ''), (r = e.length)
  for (n = 0; n < r; n++) {
    ;(i = e.charCodeAt(n)),
      i >= 1 && i <= 127
        ? (t += e.charAt(n))
        : i > 2047
        ? ((t += String.fromCharCode(224 | ((i >> 12) & 15))),
          (t += String.fromCharCode(128 | ((i >> 6) & 63))),
          (t += String.fromCharCode(128 | ((i >> 0) & 63))))
        : ((t += String.fromCharCode(192 | ((i >> 6) & 31))),
          (t += String.fromCharCode(128 | ((i >> 0) & 63))))
  }
  return t
}
var utf8to16 = function(e) {
  var t, n, r, i, s, o
  ;(t = ''), (r = e.length), (n = 0)
  while (n < r) {
    i = e.charCodeAt(n++)
    switch (i >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        t += e.charAt(n - 1)
        break
      case 12:
      case 13:
        ;(s = e.charCodeAt(n++)),
          (t += String.fromCharCode(((i & 31) << 6) | (s & 63)))
        break
      case 14:
        ;(s = e.charCodeAt(n++)),
          (o = e.charCodeAt(n++)),
          (t += String.fromCharCode(
            ((i & 15) << 12) | ((s & 63) << 6) | ((o & 63) << 0)
          ))
    }
  }
  return t
}
var encode = function(data) {
  return base64encode(utf16to8(data))
}
var decode = function(data) {
  return utf8to16(base64decode(data))
}
var sec = function() {
  let p = COMMONSEC.top.split(',')[1]
  let s = COMMONSEC.bottom.split(',')[1]
  return utf8to16(base64decode(`${p}${s}`))
}
export { encode, decode, sec }
